import { Merchant, TenantHierarchy } from '@app/models';
import { findOuById } from '../tenantHierarchy/findOuById';
import { useQueryWithErrorHandling } from '../../../hooks/UseQueryWithErrorHandling';
import { useGet } from '../../HttpClient';
import { merchantBaseUrl, tenantHierarchyBaseUrl } from '../BaseUrls';

const pillarCode = "tms";

export function useMerchantsWithOuName() {
  const get = useGet(true, pillarCode);
  const getMerchants = () => get<Merchant[]>(`${merchantBaseUrl}/merchants`);
  const getOrganisationHierarchy = () => get<TenantHierarchy>(`${tenantHierarchyBaseUrl}/organisation-hierarchy`);
  return useQueryWithErrorHandling({
    queryKey: ['get-merchants-with-ou'],
    queryFn: async () => {
      const [ouHierarchyResp, merchantsResp] = await Promise.all([getOrganisationHierarchy(), getMerchants()]);
      return merchantWithOrganisationUnitName(merchantsResp, ouHierarchyResp);
    },
  });
}

function merchantWithOrganisationUnitName(merchantsResp: Merchant[], organisationHierarchy: TenantHierarchy) {
  return merchantsResp?.map((merchant) => {
    if (organisationHierarchy?.organisationUnit) {
      const ou = findOuById(organisationHierarchy.organisationUnit, merchant.organisationUnitId);
      return { ...merchant, organisationUnitName: ou?.name };
    }
    return merchant;
  });
}
